import React from "react";
import { Link } from "react-router-dom";
import { Newspaper, Users, Globe, TrendingUp, Check } from "lucide-react";

const STATS = [
  { icon: Newspaper, value: "170+", label: "Years in print since 1854" },
  { icon: Users, value: "40,000+", label: "Weekly print & digital readers" },
  { icon: Globe, value: "95,000", label: "Monthly website visitors" },
  { icon: TrendingUp, value: "68%", label: "Readers who act on local ads" },
];

const RATES = [
  { name: "Leaderboard Banner", spec: "728 × 90 px · Top of page", price: "$450 / mo" },
  { name: "Medium Rectangle", spec: "300 × 250 px · Sidebar", price: "$325 / mo" },
  { name: "In-Content Native", spec: "Sponsored content card", price: "$500 / mo" },
  { name: "Directory Premium", spec: "Featured listing + badge", price: "$99 / mo" },
  { name: "Co-Sponsored Social", spec: "Facebook feed placement", price: "$250 / mo" },
  { name: "Full Page Print", spec: "Weekly print edition", price: "$1,200 / wk" },
];

export default function MediaKit() {
  return (
    <div className="paper-texture min-h-screen">
      <div className="border-b border-[var(--paper-border)] bg-[var(--navy)]">
        <div className="mx-auto max-w-7xl px-4 py-14">
          <p className="eyebrow text-[var(--gold)]">Advertise With Us</p>
          <h1 className="font-display text-4xl font-extrabold text-white sm:text-5xl">Media Kit & Advertising</h1>
          <p className="font-serif-body mt-3 max-w-2xl text-lg text-white/80">
            Reach the most engaged audience on Amelia Island. Locally sold banner ads, native content, premium directory listings, and co-sponsored social — plus Google AdSense remnant fill.
          </p>
        </div>
      </div>

      <div className="mx-auto max-w-7xl px-4 py-12">
        <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-4">
          {STATS.map((s) => (
            <div key={s.label} className="rounded-lg border border-[var(--paper-border)] bg-white p-6 text-center">
              <s.icon className="mx-auto mb-3 text-[var(--gold)]" size={28} />
              <p className="font-display text-4xl font-extrabold text-[var(--navy)]">{s.value}</p>
              <p className="font-ui mt-1 text-xs uppercase tracking-wider text-slate-500">{s.label}</p>
            </div>
          ))}
        </div>

        <div className="mt-14 grid gap-10 lg:grid-cols-3">
          <div className="lg:col-span-2">
            <h2 className="section-rule font-display pt-3 text-2xl font-bold text-[var(--navy)]">Rates & Placements</h2>
            <div className="mt-6 overflow-hidden rounded-lg border border-[var(--paper-border)]">
              <table className="w-full text-left">
                <thead className="bg-[var(--navy)] text-white">
                  <tr className="font-ui text-xs uppercase tracking-wider">
                    <th className="px-4 py-3">Placement</th>
                    <th className="px-4 py-3">Specifications</th>
                    <th className="px-4 py-3 text-right">Rate</th>
                  </tr>
                </thead>
                <tbody className="divide-y divide-[var(--paper-border)] bg-white">
                  {RATES.map((r) => (
                    <tr key={r.name} className="font-serif-body text-sm">
                      <td className="px-4 py-3 font-semibold text-[var(--ink)]">{r.name}</td>
                      <td className="px-4 py-3 text-slate-600">{r.spec}</td>
                      <td className="px-4 py-3 text-right font-bold text-[var(--navy)]">{r.price}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            <p className="font-ui mt-3 text-xs text-slate-500">
              Unsold inventory is filled automatically via Google AdSense, so every placement earns. Bundle discounts available.
            </p>
          </div>

          <div>
            <h2 className="section-rule font-display pt-3 text-2xl font-bold text-[var(--navy)]">Why advertise here</h2>
            <ul className="mt-6 space-y-3">
              {["Trusted name since 1854", "Hyper-local Nassau County reach", "Print + digital + social bundles", "Co-sponsored Facebook program", "Premium business directory", "Dedicated local ad rep"].map((f) => (
                <li key={f} className="font-serif-body flex items-start gap-2 text-slate-700">
                  <Check size={18} className="mt-0.5 shrink-0 text-[var(--gold)]" /> {f}
                </li>
              ))}
            </ul>
            <div className="mt-8 rounded-lg bg-[var(--navy)] p-6 text-white">
              <h3 className="font-display text-xl font-bold">Talk to our ad team</h3>
              <p className="font-serif-body mt-1 text-sm text-white/80">advertising@fbnewsleader.com · (904) 261-3696</p>
              <Link to="/directory" className="font-ui mt-4 inline-block rounded-full bg-[var(--gold)] px-5 py-2 text-xs font-semibold uppercase tracking-wider text-white hover:bg-[#b08f48]">
                List Your Business
              </Link>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
